var COJ = COJ || {};

COJ.SearchForm = function() {

    var _form = $('.form--search');
    var _input = _form.find('input[name="q"]');

    var _init = function() {
        if (_form.length) {
            _form.on('submit', function(e) {
                if (_input.val() === '') {
                    e.preventDefault();
                }
            });
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    COJ.SearchForm.init();
});
